import { Decorative } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import styled from "styled-components";

export const VanillaBackground = styled(Column)`
  background: ${Decorative.tint.neutral};
`;

export const ContentContainer = styled(Column)`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;
